import { SlidersHorizontal } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const SlidersIcon = createLucideIcon(SlidersHorizontal);
